import React from 'react';
import { Icon } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const DictionaryConvertToastComplete = ({ dictionaryName }) => (
  <div className="aridhia-dictionary-convert-complete-toast toast-success toast-message">
    <Icon name="check circle" color="green" />
    <FormattedMessage id="dataset.convert.toast.dictionary.success" values={{ dictionaryName }} />
  </div>
);

export default DictionaryConvertToastComplete;
